// extracted by mini-css-extract-plugin
export var layoutContainer = "_4u-0";
export var layoutContainerNoRounding = "_4u-6";
export var layoutContainerOpen = "_4u-5";
export var layoutContainerResizing = "_4u-1";
export var mainContent = "_4u-2";
export var resizeDivider = "_4u-3";
export var slidePanel = "_4u-4";